import React from 'react';
import clsx from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../../common/views/SMLButton/SMLButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cards and the preview line */
import styles from './UnlockCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface UnlockCardProps {
  icon: IconProp;
  title: string;
  body: string;
  action: string;
  isPrimary: boolean;
  /** The part is in: the card is grey with a check and has no button (design c5 note). */
  isDone?: boolean;
  /** The label of the done state, in place of the button. */
  doneLabel?: string;
  onAction: () => void;
}

/**
 * One unlock card (design: onboarding c5 `.ob-uc`). The first card with something missing is
 * primary. A done card stays, grey with a check, while the other card still has work; the row
 * goes when both are done.
 */
const UnlockCardComponent: React.FC<UnlockCardProps> = ({
  icon,
  title,
  body,
  action,
  isPrimary,
  isDone = false,
  doneLabel,
  onAction,
}) => (
  <div
    className={clsx(styles.card, isPrimary && !isDone && styles.cardPrimary, isDone && styles.cardDone)}
    data-testid="unlock-card"
    data-done={isDone ? 'true' : undefined}
  >
    <span className={styles.icon}>
      <FontAwesomeIcon icon={isDone ? faCheck : icon} />
    </span>
    <div className={styles.text}>
      <b>{title}</b>
      <small>{body}</small>
    </div>
    {isDone ? (
      <span className={styles.doneLabel}>{doneLabel}</span>
    ) : (
      <SMLButton size="sm" omitCap color={isPrimary ? 'primary' : 'secondary'} outline={!isPrimary} onClick={onAction}>
        {action}
      </SMLButton>
    )}
  </div>
);

export const UnlockCard = TypedMemo(UnlockCardComponent);
